import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const style: CSSResult = css`
  cse-text + cse-text {
    display: block;
    margin-top: ${csSpacing.spacing06};
	}
`
